//cspell:disable
export const excludedDomains = [
  'gmail',
  'gamil',
  'gmai',
  'gemail',
  'gimail',
  'gmil',
  'gmli',
  'gmaio',
  'gmali',
  'gmsil',
  'googlemail',
  'outlook',
  'hotmail',
  'live',
  'msn',
  'yahoo',
  'ymail',
  'rocketmail',
  'icloud',
  'me',
  'mac',
  'aol',
  'proton',
  'protonmail',
  'zoho',
  'gmx',
  'gmx',
  'mail',
  'email',
  'usa',
  'consultant',
  'yandex',
  'yandex',
  'fastmail',
  'terra',
];
